<template>
  <div class="flex h-auto bg-gray-900 text-white">
    <!-- Sidebar -->
    <aside
      class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700"
    >
      <div class="flex items-center justify-center space-x-3">
        <img src="@/assets/logo.svg" alt="Vultric Logo" class="h-20" />
      </div>
      <Navbar />
    </aside>

    <!-- Main Content -->
    <div class="flex-1 flex flex-col">
      <!-- Header -->
      <header
        class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md bg-gradient-to-b from-gray-800 to-gray-900 border-b border-gray-700"
      >
        <h2 class="text-xl font-semibold">Network</h2>
      </header>

      <main class="p-6 flex-1 space-y-8">
        <!-- Add Request -->
        <div
          class="p-6 bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700 rounded-xl shadow-lg"
        >
          <h3 class="text-lg font-semibold mb-4">Request IP / ASN</h3>
          <form @submit.prevent="submitRequest" class="space-y-4">
            <div>
              <label class="block text-sm mb-1">Type</label>
              <select
                v-model="newRequest.type"
                class="w-full p-2 bg-gray-700 border border-gray-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="ip">IP Range</option>
                <option value="asn">ASN</option>
              </select>
            </div>

            <div>
              <label class="block text-sm mb-1">{{
                newRequest.type === "ip" ? "IP Range" : "ASN"
              }}</label>
              <input
                v-model="newRequest.value"
                type="text"
                class="w-full p-2 bg-gray-700 border border-gray-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                :placeholder="newRequest.type === 'ip' ? 'e.g. 192.168.0.0/24' : 'e.g. AS12345'"
                required
              />
            </div>

            <button
              type="submit"
              class="bg-blue-600 px-4 py-2 rounded text-white hover:bg-blue-700 shadow-md"
            >
              Submit Request
            </button>
          </form>
        </div>

        <!-- Pending Requests -->
        <div
          v-if="pendingRequests.length"
          class="p-6 bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700 rounded-xl shadow-lg"
        >
          <h3 class="text-lg font-semibold mb-4">Pending Requests</h3>
          <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div
              v-for="req in pendingRequests"
              :key="req.id"
              class="p-4 bg-gray-800 border border-gray-700 rounded-lg shadow-md flex flex-col"
            >
              <div class="flex justify-between items-center mb-2">
                <span class="font-medium capitalize">{{ req.type }}</span>
                <span
                  class="px-2 py-1 text-xs rounded-full bg-yellow-500 text-black font-semibold"
                  >Pending</span
                >
              </div>
              <p class="text-gray-300 break-words">{{ req.value }}</p>
            </div>
          </div>
        </div>

        <!-- Approved Network Data -->
        <div
          class="p-6 bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700 rounded-xl shadow-lg"
        >
          <h3 class="text-lg font-semibold mb-4">Approved Network Resources</h3>
          <div
            v-if="networkData.length"
            class="grid md:grid-cols-2 lg:grid-cols-3 gap-4"
          >
            <div
              v-for="net in networkData"
              :key="net.id"
              class="p-4 bg-gray-800 border border-gray-700 rounded-lg shadow-md"
            >
              <div class="flex justify-between items-center mb-2">
                <span class="font-medium capitalize">{{ net.type }}</span>
                <span
                  class="px-2 py-1 text-xs rounded-full bg-green-500 text-black font-semibold"
                  >Active</span
                >
              </div>
              <p class="text-gray-300 break-words">{{ net.value }}</p>
            </div>
          </div>

          <p v-else class="text-gray-400">No approved resources yet.</p>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/nav.vue";
import axios from "axios";

export default {
  name: "NetworkPage",
  data() {
    return {
      networkData: [],
      pendingRequests: [],
      newRequest: { type: "ip", value: "" },
    };
  },
  methods: {
    async fetchNetworkData() {
      try {
        const res = await axios.get(
          "https://api.syniac.com:3000/api/network/list",
          { withCredentials: true }
        );
        this.networkData = res.data.confirmed;
        this.pendingRequests = res.data.pending;
      } catch (error) {
        console.error("Error fetching network data:", error);
      }
    },
    async submitRequest() {
      if (!this.newRequest.value.trim()) return;
      try {
        await axios.post(
          "https://api.syniac.com:3000/api/network/request",
          this.newRequest,
          { withCredentials: true }
        );
        this.newRequest.value = "";
        this.fetchNetworkData();
      } catch (error) {
        console.error("Error submitting request:", error);
      }
    },
  },
  mounted() {
    this.fetchNetworkData();
  },
  components: { Navbar },
};
</script>
